(function () {
  var KEY = 'fcWishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('fc-wishlist:change', { detail: arr.slice() }));
  }

  var FCWishlist = {
    all: function () { return read(); },
    has: function (h) { return read().indexOf(h) !== -1; },
    add: function (h) {
      var a = read();
      if (a.indexOf(h) === -1) { a.push(h); write(a); }
    },
    remove: function (h) {
      write(read().filter(function (x) { return x !== h; }));
    },
    toggle: function (h) {
      if (this.has(h)) { this.remove(h); return false; }
      this.add(h); return true;
    },
    count: function () { return read().length; }
  };

  function money(cents, currency) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency || 'USD', maximumFractionDigits: 2
      }).format(n);
    } catch (e) { return (currency || '') + ' ' + n.toFixed(2); }
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  function buildCard(p) {
    var card = document.createElement('a');
    card.className = 'fc-wishlist-card';
    card.href = '/products/' + p.handle;

    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img) {
      var i = document.createElement('img');
      i.className = 'fc-wishlist-card__image';
      i.loading = 'lazy';
      i.alt = p.title || '';
      i.src = imgUrl(img, 600);
      card.appendChild(i);
    } else {
      var ph = document.createElement('div');
      ph.className = 'fc-wishlist-card__image fc-wishlist-card__image--placeholder';
      card.appendChild(ph);
    }

    var body = document.createElement('div');
    body.className = 'fc-wishlist-card__body';

    var title = document.createElement('h3');
    title.className = 'fc-wishlist-card__title';
    title.textContent = p.title || '';
    body.appendChild(title);

    var price = document.createElement('p');
    price.className = 'fc-wishlist-card__price';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    price.textContent = money(p.price, cur);
    body.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'fc-wishlist-card__actions';
    var view = document.createElement('span');
    view.className = 'fc-wishlist-card__view';
    view.textContent = 'View Product →';
    actions.appendChild(view);
    body.appendChild(actions);

    card.appendChild(body);

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'fc-wishlist-card__remove';
    rm.setAttribute('aria-label', 'Remove from wishlist');
    rm.innerHTML = '&times;';
    rm.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      FCWishlist.remove(p.handle);
    });
    card.appendChild(rm);

    return card;
  }

  function renderInto(grid, empty) {
    if (!grid) return;
    var handles = FCWishlist.all();

    if (handles.length === 0) {
      grid.innerHTML = '';
      grid.style.display = 'none';
      if (empty) empty.style.display = 'block';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.style.display = '';

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var stale = [];
      grid.innerHTML = '';
      results.forEach(function (p, i) {
        if (!p) { stale.push(handles[i]); return; }
        grid.appendChild(buildCard(p));
      });
      if (stale.length) {
        var keep = FCWishlist.all().filter(function (h) { return stale.indexOf(h) === -1; });
        try { localStorage.setItem(KEY, JSON.stringify(keep)); } catch (e) {}
      }
    });
  }

  FCWishlist.renderInto = renderInto;
  window.FCWishlist = FCWishlist;
})();
